import type { JDSAvatarV2InformationProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSAvatarV2InformationProps>
  ): React.FC<JDSAvatarV2InformationProps> =>
  (props: JDSAvatarV2InformationProps) => {
    return <Component {...props} />;
  };
export { JDSAvatarV2InformationProps };
